import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
export function BuySection() {
  return <section className="bg-brand-orange py-12 md:py-16 px-4 relative overflow-hidden" data-id="element-27">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.1),transparent_60%)] pointer-events-none" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-30">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6" data-id="element-31">
            <ShoppingCartIcon className="w-4 h-4 text-white" data-id="element-32" />
            <span className="text-sm font-bold text-white tracking-wide uppercase" data-id="element-33">
              Compra Directa
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 text-balance leading-tight" data-id="element-34">
            ¿Listo Para Comprar Tus Leads?
          </h2>

          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-35">
            Explora nuestro catálogo completo de leads verificados y empieza a
            cerrar ventas hoy mismo.
          </p>

          <div className="max-w-2xl mx-auto mb-8 rounded-xl overflow-hidden shadow-lg" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/bh9BANYPCRusYnYfVEJ1Qy/Screenshot_2026-03-18_at_11.59.31_AM.png" alt="Paquetes de leads de Xclusive Agent Leads" className="w-full h-auto object-contain" loading="lazy" decoding="async" data-id="element-37" />
          </div>

          <a href="https://xclusiveagentleads.com/collections/todos-los-leads" target="_blank" rel="noopener noreferrer" className="inline-block bg-white hover:bg-gray-100 text-brand-orange px-8 md:px-12 py-5 rounded-xl font-bold text-base md:text-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-38">
            Comprar Leads Ahora →
          </a>
        </motion.div>
      </div>
    </section>;
}